import { render, staticRenderFns } from "./onebox-package-new.vue?vue&type=template&id=3e2df9d9&scoped=true&"
import script from "./onebox-package-new.vue?vue&type=script&lang=js&"
export * from "./onebox-package-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-package-new.vue?vue&type=style&index=0&id=3e2df9d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2df9d9",
  null
  
)

export default component.exports